<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/fair_reward/table/'+fairid}">获奖记录</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="searchRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-form-item prop="deliver_id"
                      label="物流公司:">
          <el-select v-model="form.deliver_id"
                     placeholder="请选择">
            <el-option v-for="item in options.deliver_company"
                       :key="item.deliver_id"
                       :label="item.deliver_company"
                       :value="item.deliver_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="deliver_order_number"
                      label="物流单号:">
          <el-input v-model="form.deliver_order_number"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit"
                     v-if="loading">确认
          </el-button>
          <router-link :to="{ path: '/fair_reward/table/'+fairid}">
            <el-button>取消</el-button>
          </router-link>
        </el-form-item>
      </el-form>

    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../fairReward.rules.js'

export default {
  data () {
    return {
      searchRules,
      fairid: this.$route.query.fairid,
      form: {
        id: this.$route.params.id,
        deliver_order_number: null,
        deliver_id: null,
        deliver_company: null,
      },
      loading: true,
      options: {
        deliver_company: [],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.all.page([
      request('getLogisticsCompany', {status: 1}),
      request('getRewardLogistics', this.form.id),
    ]).then(([{data: companyData}, {data: rewardData}]) => {
      this.options.deliver_company = companyData
      filter.setLoop(this.form, rewardData)
    })
  },
  methods: {
    ...Vuex.mapActions(['editRewardLogistics', 'getLogisticsCompany', 'getRewardLogistics']),

    onSubmit () {
      for (let i = 0; i < this.options.deliver_company.length; i++) {
        if (this.form.deliver_id === this.options.deliver_company[i].deliver_id) {
          this.form.deliver_company = this.options.deliver_company[i].deliver_company
        }
      }
      this.$refs['form'].validate((valid) => {
        this.loading = false
        if (valid) {
          return request.common('editRewardLogistics', this.form).then((data) => {
            this.$message({
              showClose: true,
              message: '物流信息保存成功',
              type: 'success',
            })
          }, () => {
            this.loading = true
          })
        } else {
          this.loading = true
          this.$message.error('提交内容填写不正确！')
        }
      })
    },

  },

}
</script>



// WEBPACK FOOTER //
// src/views/fair-reward/pages/FairRewardUpdate.vue